import {StembleTheme} from '@/theme/types';
import {lightTheme} from '@/theme/themes/lightTheme';

export const darkTheme: StembleTheme = {
  ...lightTheme,
};
